import { Box, CircularProgress, Paper } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";

import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { compose } from "recompose";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { serverMsg } from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import ChallanHeader from "./components/ChallanHeader";
import Signoff from "./components/Signoff";
import StockReconciliation from "./components/StockReconciliation";
import { S } from "./styles/ChallanSettlementStyles";
import GlobalStyles from "./styles/GlobalStyles";
import { takeSettlementPrefetch } from "./settlementPrefetchCache";


const INITIAL_DAMAGE_DATA = { damagedUnits: 0, estimatedDamageValue: 0 };

const ChallanSettlement = ({
    showNotification,
}) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const prefetchRef = useRef(takeSettlementPrefetch(id));

    const [stockGap, setStockGap] = useState(0);
    const [damageData, setDamageData] = useState(INITIAL_DAMAGE_DATA);
    const [hasPhysicalReturn, setHasPhysicalReturn] = useState(false);
    const [challanData, setChallanData] = useState({});
    const [enrichedRows, setEnrichedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const getDayEndDetails = async () => {
            setIsLoading(true);
            setChallanData({});
            setEnrichedRows([]);
            setStockGap(0);
            setHasPhysicalReturn(false);

            try {
                const prefetch = prefetchRef.current;
                prefetchRef.current = null;

                const { data, success } = prefetch
                    ? await prefetch
                    : await apiGet({
                        url:
                            endpoint.vanStockTransferHeader +
                            "/day-end-details-by-driver-for-challan?challanId=" +
                            id,
                    });

                if (cancelled) return;

                if (success) {
                    if (data?.data && Object.keys(data.data).length > 0) {
                        setChallanData(data.data);
                    }
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            } catch (error) {
                console.error("Error fetching day end details:", error);
            } finally {
                if (!cancelled) {
                    setIsLoading(false);
                }
            }
        };

        getDayEndDetails();

        return () => {
            cancelled = true;
        };
    }, [id, showNotification]);

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        // <Paper sx={{ borderRadius: 0, overflow: "visible" }} elevation={0}>
        <Paper sx={{ p: 2, borderRadius: 0 }} elevation={0}>

            <GlobalStyles />

            <LandingScreenHeader
                showTitle
                screenTitle="Challan Settlement"
                showSaveBtnMain={false}
                showAddButton={false}
                showBackButton={true}
                onCancel={handleCancel}
            />

            <div style={S.page} className="cs-page-inner">
                <div style={S.container}>
                    {isLoading ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: 280,
                            }}
                        >
                            <CircularProgress size={36} />
                        </Box>
                    ) : (
                        <>
                            <ChallanHeader stockGap={stockGap} challanData={challanData} />

                            <StockReconciliation
                                onGapChange={setStockGap}
                                onDamageChange={setDamageData}
                                onPhysicalCountEntered={setHasPhysicalReturn}
                                vanStockTransferDetail={challanData.vanStockTransferDetail}
                                onRowsChange={setEnrichedRows}
                                challanHeaderId={id}
                            />

                            {/* Comment by tejas (01-06-2026): As per Akash sir,Payment settlement section
                             & Damage returns section are not required. Hence commenting out. */}

                            {/* <PaymentSettlement /> */}

                            {/* <OutstandingDues /> */}

                            {/* <DamageReturns
                                damagedUnits={damageData.damagedUnits}
                                estimatedDamageValue={damageData.estimatedDamageValue}
                            /> */}

                            <Signoff
                                hasPhysicalReturn={hasPhysicalReturn}
                                challanData={challanData}
                                enrichedRows={enrichedRows}
                            />
                        </>
                    )}
                </div>
            </div>
        </Paper>
    );
};



const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ChallanSettlement);
